export const SITE = {
  name: "Hot Sauce Media",
  tagline: "Social that bites back.",
  cities: ["PUNE"],
  instagram: "hotsaucelab",
  instagramUrl: "https://instagram.com/hotsaucelab",
  phone: "7387882751",
  phoneDisplay: "+91 738 788 2751",
  email: "connect@hotsaucemedia.in",
};

export const SERVICES = [
  {
    code: "01",
    name: "End-to-End Content System",
    desc: "From strategy to execution, we build, manage, and scale your account.",
  },
  {
    code: "02",
    name: "Creative Campaigns",
    desc: "Campaigns built around clear ideas, strong storytelling, and memorable creative.",
  },
  {
    code: "03",
    name: "Social Media Management",
    desc: "Planning, publishing, and managing your social presence with consistency and care.",
  },
  {
    code: "04",
    name: "Content Creation",
    desc: "Reels, videos, and social-first content created to engage and perform.",
  },
];

export const WORK = [
  {
    slug: "chai-cartel",
    client: "Chai Cartel",
    category: "F&B / D2C",
    year: "2025",
    metric: "+412% Reels reach",
    tag: "REELS",
    color: "#FF1111",
    blurb: "Rebuilt a tired chai brand into a Gen Z ritual. Six formats, one hook: 'sip loud'.",
    img: "https://images.unsplash.com/photo-1613498401195-33546cd26db3?w=1200&q=80",
  },
  {
    slug: "kachra-club",
    client: "Kachra Club",
    category: "Streetwear",
    year: "2025",
    metric: "18k → 214k in 90 days",
    tag: "IDENTITY",
    color: "#09090B",
    blurb: "A streetwear label with attitude. New logo system, drop trailers, meme calendar.",
    img: "https://images.unsplash.com/photo-1523398002811-999ca8dec234?w=1200&q=80",
  },
  {
    slug: "loose-motion",
    client: "Loose Motion FC",
    category: "Sports / Community",
    year: "2024",
    metric: "3.2M organic views",
    tag: "COMMUNITY",
    color: "#FF1111",
    blurb: "Grassroots football league in Pune. Weekly recap edits, player mini-docs, sold-out kits.",
    img: "https://images.unsplash.com/photo-1517649763962-0c623066013b?w=1200&q=80",
  },
  {
    slug: "misal-mafia",
    client: "Misal Mafia",
    category: "F&B / QSR",
    year: "2024",
    metric: "9x footfall on launch weekend",
    tag: "LAUNCH",
    color: "#09090B",
    blurb: "Pune misal chain launch. Teaser reels, influencer relay, day-of-launch flood.",
    img: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200&q=80",
  },
  {
    slug: "studio-noir",
    client: "Studio Noir",
    category: "Beauty / DTC",
    year: "2025",
    metric: "6.1% CTR on paid",
    tag: "PAID",
    color: "#FF1111",
    blurb: "Indie nail brand. Creator-led paid ads, UGC ops, glossy but greasy.",
    img: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=1200&q=80",
  },
  {
    slug: "bhaad-mein-jao",
    client: "Bhaad Mein Jao",
    category: "Media / Podcast",
    year: "2024",
    metric: "#3 Spotify India (Comedy)",
    tag: "CONTENT",
    color: "#09090B",
    blurb: "Podcast studio identity + weekly cutdowns. Bilingual hooks and a sharp tongue.",
    img: "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=1200&q=80",
  },
];

export const VALUES = [
  { code: "V/01", label: "Loud on purpose", body: "Quiet brands die. We make you unignorable, then figure out the tone later." },
  { code: "V/02", label: "Native, always", body: "Every platform is a language. We don't translate — we write in it." },
  { code: "V/03", label: "Data + gut", body: "Analytics is our co-pilot. Instinct still drives." },
  { code: "V/04", label: "Ship weekly", body: "Big brand books are dead. We ship, learn, remix. Every Monday." },
];

export const TEAM = [
  { name: "Rajashri", role: "Founder / Creative Director", city: "Pune" },
  { name: "Omkar", role: "Co-founder / Head of Video", city: "Pune" },
  { name: "Piyush", role: "Co-founder / Graphic Designer", city: "Pune" },
];

export const BUDGETS = [
  "< 50k / month",
  "50k – 1.5L / month",
  "1.5L – 5L / month",
  "5L+ / month",
  "One-off project",
];
